import _createForOfIteratorHelper from "/opt/github/_work/frontend-website-cms/frontend-website-cms/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import $ from "cash-dom";
import { findKey } from "lodash";
import queryString from "query-string";
import { stateToFips } from "./chartModifiers";

function loadScript(url, callback) {
  var script = document.createElement("script");
  script.type = "text/javascript";

  if (script.readyState) {
    // IE
    script.onreadystatechange = function () {
      if (script.readyState === "loaded" || script.readyState === "complete") {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    // Others
    script.onload = function () {
      callback();
    };
  }

  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
}

export default function () {
  var queryState = queryString.parse(location.search).state ? queryString.parse(location.search).state : [];
  var states = Array.isArray(queryState) ? queryState : [queryState];

  var _iterator = _createForOfIteratorHelper(states),
      _step;

  try {
    var _loop = function _loop() {
      var item = _step.value;
      var key = findKey(stateToFips, function (st) {
        return st === item;
      });
      $("[data-state='".concat(key, "']")).addClass("active");
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  $("#finance-table-container").attr("data-states", JSON.stringify(states));
  $("#finance-table-container").attr("data-geo", !!states.length);
  var src = $("#finance-table-container").attr("data-src");
  loadScript(src, function () {});
  var links = $(".finance-table .anchormenu__link");
  links.removeClass("is-active");
  $(links[0]).addClass("is-active");
  links.on("click", function () {
    links.removeClass("is-active");
    $(this).addClass("is-active");
  });
}